/**
 * 09.10.26. Не удалять по требованию владельца системы.
 * Одна формулировка связей нотифаера для экранов и heartbeat.
 * Крон — heartbeat L3, не проверка что процесс жив.
 */
export const FLOW_TEXT = {
  canon:
    'L1 — процесс отвечает. Это не база, не Redis и не каналы. L2 — общая PostgreSQL, общий Redis и своя база клиники. L3 — каналы, датаслой, Knowledge Hub, отбивка в Helper Bot и кроны. У каждой проверки стоит дата и время.',
  template:
    'Один шаблон — один канал. Похожий текст на другом канале заводится отдельным шаблоном.',
  autoreply:
    'Автоответ висит на шаблоне своего канала: кнопка WABA или бота, текст по regex, либо кнопка на лендинге OKDoc.',
  interaction:
    'Ответ на подтверждение, сбор ОС или день рождения попадает во взаимодействия. В очередь рассылок автоответ не кладётся: его видно в истории сообщений.',
  okdocLanding:
    'Кнопка внутри лендинга, например «Приду», связана с шаблоном, который открыл страницу, и с переходом OKDoc.',
  okdocTracking:
    'Переход OKDoc — это нажатие кнопки на лендинге. Лендинг открывается из шаблона.',
  queue:
    'Авто и ручной режим попадают в очередь со шильдиком режима. Авто ставит крон. Живость крона — heartbeat L3: дата и время последней отработки, не ответ /health.',
  history:
    'История собирает и регулярные, и ручные отправки после очереди.',
  appointments:
    'На одну запись завязаны разные шаблоны: заранее, за 24 часа, за 2 часа и сбор ОС. Одному пациенту они уходят в разное время. Синк приёмов и пациентов виден по дате последней записи в базу: для отправки нужны время, статус и телефон.',
  birthday:
    'Выбор подарка ко дню рождения уходит отбивкой в Helper Bot General. На heartbeat это связь по каждой клинике, без отправки сообщения.',
} as const;

export type FlowId = keyof typeof FLOW_TEXT;

export const EDGE_LABEL: Record<string, string> = {
  postgres: 'PostgreSQL',
  redis: 'Redis',
  data_layer: 'Датаслой',
  knowledge_hub: 'Clinic Knowledge Hub',
  helper_bot_birthday: 'Отбивка в Helper Bot',
  pipeline_confirmations: 'Подтверждения',
  pipeline_feedback: 'Сбор ОС',
  pipeline_birthday: 'День рождения',
  sync_appointments: 'Синк приёмов',
  sync_patients: 'Синк пациентов',
  segments: 'Сегменты',
  waba_templates: 'Шаблоны WABA',
  sms_tel: 'SMS-Tel',
};

export const JOB_LABEL: Record<string, string> = {
  pipeline_probe: 'Проба каналов',
  queue_dispatch: 'Очередь отправок',
  regular_broadcasts: 'Регулярные рассылки',
  reminder_advance: 'Напоминание заранее',
  reminder_2h: 'Напоминание за 2 часа',
  reminder_24h: 'Напоминание за 24 часа',
  feedback_request: 'Сбор ОС',
  birthday: 'День рождения',
};
